export default "__VITE_ASSET__QHzHjNE0__"